import { FCX } from "@datassential/platform-ui-lib";
import { useHistoricTrendContext } from "@pages/Trend/components/HistoricTrend/HtContext";
import { useCallback, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import { HistoricTrendTableItem } from "@api/useHistoricTrend";
import cn from "classnames";

const HistoricTrendChartInfoItem: FCX<{
	item: HistoricTrendTableItem;
	color: string,
}> = ({
	item,
	color,
	testId,
}) => {
	const {
		setActiveSeriesId,
		selectedItems,
		setSelectedItems,
	} = useHistoricTrendContext();

	useEffect(() => {
		setActiveSeriesId(null);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedItems]);

	const handleMouseEnter = useCallback(() => {
		setActiveSeriesId(item.id ?? null);
	}, [item.id, setActiveSeriesId]);

	const handleMouseLeave = useCallback(() => {
		setActiveSeriesId(null);
	}, [setActiveSeriesId]);

	const handleClose = useCallback(() => {
		setSelectedItems(selectedItems.filter((selItem) => selItem.id !== item.id));
	}, [item.id, selectedItems, setSelectedItems]);

	return (
		<div
			className={
				cn(
					"HtChartInfo__item",
					"appears",
					"fast"
				)
			}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			data-testid={testId}
		>
			<div className="HtChartInfo__item-left">
				<div
					className="HtChartInfo__item-value"
					style={{ backgroundColor: color }}
					data-testid="blockHistoricTrendItemColor"
				/>
				<span data-testid="textHistoricTrendItemName">{item.name?.toUpperCase()}</span>
			</div>
			<div className="HtChartInfo__item-right">
				<span
					className="HtChartInfo__item-change"
					data-testid="textHistoricTrendItemChange"
				>
					{item.changeValueSigned}
				</span>
				<IoClose
					className="HtChartInfo__item-close"
					data-testid="buttonHistoricTrendItemRemove"
					onClick={handleClose}
				/>
			</div>
		</div>
	);
};

export default HistoricTrendChartInfoItem;